import { L1AllowList } from "@turnstile-portal/turnstile.js";
import { isAddress } from "viem/utils";
import { getL1AllowListAddr } from "../lib/addresses";
import { getL1ClientAsync } from "../wagmi";

export async function proposeToken(tokenAddress: string) {
  // check if the token is a valid address
  if (!isAddress(tokenAddress)) {
    throw new Error("Invalid token address");
  }

  const l1Client = await getL1ClientAsync();
  const allowList = new L1AllowList(getL1AllowListAddr(), l1Client);

  // Propose the token to the allowlist
  const receipt = await allowList.propose(tokenAddress);
  console.log(`Proposed token to portal in tx ${receipt.transactionHash}`);

  return receipt.transactionHash;
}
